import React from 'react'
import PropTypes from 'prop-types'
import {
  Sidebar,
  SidebarNavigation,
  SidebarLockup
} from 'belle-js'

import classnames from 'classnames'
import AccountHolderFormGroup from './AccountHolderFormGroup/AccountHolderFormGroup'
import FinancialAccountFormGroup from './FinancialAccountFormGroup/FinancialAccountFormGroup'
import SidebarLink from './SidebarLink/SidebarLink'
import styles from './PWMSidebar.module.scss'
import { isOnboardingRoute } from 'routing/routes'
import C from 'actionTypes/onboarding/routing'

const PWMSidebar = (props) => {
  const {
    prospect,
    financialAccounts,
    isLoading,
    financialAccountsCollapsed,
    sidebarDataLoaded,
    setFinancialAccountCollapsed,
    overview,
    isMobile,
    siteNavOpen,
    closeNav,
    location
  } = props

  const isFixed = isMobile
  const isOpen = !isMobile || siteNavOpen

  const { onboardingFinancialAccountsVisible } = prospect
  const reviewAndSubmitText = onboardingFinancialAccountsVisible ? '3. Review & Submit' : 'Review & Submit'

  if (isLoading && !sidebarDataLoaded) {
    return null
  }

  const route = location.type
  const showSidebar = isOnboardingRoute(route, false) && route !== 'ONBOARDING_CONFIRMATION'
  return (
    showSidebar &&
    <div className={styles.PWMSidebar}>
      <Sidebar
        isFixed={isFixed}
        isOpen={isOpen}
        closeSidebar={closeNav}
        className="sidebar">
        {isFixed &&
          <a style={{ alignSelf: 'flex-start' }}>
            <SidebarLockup orientation="horizontal" />
          </a>
        }
        <div className={classnames(styles.sidebarDivider, styles.headerDivider)} />
        <SidebarNavigation>
          <ul className={styles.firstHeading}>
            <li>
              <SidebarLink to={{ type: C.ONBOARDING_GETTING_STARTED }} name="Getting Started" />
            </li>
          </ul>
          <li>
            <div className={styles.sidebarDivider} />
          </li>
          <ul className={styles.heading}>
            <li>
              {onboardingFinancialAccountsVisible
                &&
                <SidebarLink className={styles.section} to={{ type: C.ONBOARDING_ABOUT_YOU }} name="1. About you" />
              }
              <AccountHolderFormGroup overview={overview.aboutYou} />
            </li>
          </ul>
          {onboardingFinancialAccountsVisible &&
            <div className={styles.sidebarDivider} />}
          {onboardingFinancialAccountsVisible &&
            <ul className={styles.heading}>
              <li>
                <SidebarLink className={styles.section} to={{ type: C.ONBOARDING_YOUR_ACCOUNTS }} name="2. Your accounts" />
                <FinancialAccountFormGroup
                  financialAccounts={financialAccounts}
                  financialAccountsCollapsed={financialAccountsCollapsed}
                  setCollapsed={setFinancialAccountCollapsed}
                  overview={overview.yourAccounts} />
              </li>
            </ul>}
          <li>
            <div className={styles.sidebarDivider} />
          </li>
          <li>
            <ul className={styles.heading}>
              <li>
                <SidebarLink
                  to={{ type: C.ONBOARDING_REVIEW_AND_SUBMIT }}
                  name={reviewAndSubmitText} />
              </li>
            </ul>
          </li>
          <li>
            <div className={styles.sidebarDivider} />
          </li>
        </SidebarNavigation>
      </Sidebar>
    </div>
  )
}

PWMSidebar.defaultProps = {
  closeNav () {},
  financialAccounts: [],
  financialAccountsCollapsed: {},
  overview: {},
  showSidebar: false,
}

PWMSidebar.propTypes = {
  location: PropTypes.object.isRequired,
  isMobile: PropTypes.bool.isRequired,
  siteNavOpen: PropTypes.bool.isRequired,
  closeNav: PropTypes.func,
  showSidebar: PropTypes.bool,
  prospect: PropTypes.object.isRequired,
  financialAccounts: PropTypes.array,
  isLoading: PropTypes.bool.isRequired,
  financialAccountsCollapsed: PropTypes.object,
  sidebarDataLoaded: PropTypes.bool.isRequired,
  setFinancialAccountCollapsed: PropTypes.func.isRequired,
  overview: PropTypes.object,
}

export default PWMSidebar



// WEBPACK FOOTER //
// ./src/components/Onboarding/PWMSidebar/PWMSidebar.jsx